import './FlexItem.scss';

import PropTypes from 'prop-types';
import React from 'react';

const FlexItem = ({ className, order, flexGrow, flexShrink, flexBasis, alignSelf, style, children, onClick }) => {
	const onClickHandler = e => {
		onClick(e);
	};

	return (
		<div
			className={`react__flex-item ${className}`}
			data-align-self={alignSelf}
			data-flex-basis={flexBasis}
			data-flex-grow={flexGrow}
			data-flex-shrink={flexShrink}
			data-order={order}
			role='listbox'
			style={style}
			tabIndex='0'
			onClick={e => onClickHandler(e)}
		>
			{children}
		</div>
	);
};

FlexItem.propTypes = {
	order: PropTypes.number,
	flexGrow: PropTypes.number,
	flexShrink: PropTypes.number,
	flexBasis: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	alignSelf: PropTypes.oneOf(['auto', 'flex-start', 'flex-end', 'center', 'baseline', 'stretch']),
	className: PropTypes.string,
	onClick: PropTypes.func,
	style: PropTypes.object,
	children: PropTypes.any.isRequired
};

FlexItem.defaultProps = {
	order: 0,
	flexGrow: 0,
	flexShrink: 0,
	flexBasis: 'auto',
	alignSelf: 'auto',
	className: '',
	style: {},
	onClick: () => {}
};

export default FlexItem;
